__turbopack_context__.v({
  "className": "inter_3d19388c-module__Yml5OW__className",
  "variable": "inter_3d19388c-module__Yml5OW__variable",
});
